import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8 * (props.wx ?? 1)}
    height={31 * (props.hx ?? 1)}
    viewBox="0 0 8 31"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.453 1.998c-.008-.521-.196-.761-.66-.833C5.98 1.04 5.013 1 4.23 1s-1.75.039-2.564.165c-.463.072-.652.311-.66.833-.028 1.793.064 5.261.233 6.663.029.24.074.485.149.72.177.555.32 1.112.335 1.695.053 2.12.26 4.426.347 6.762.128 3.445.096 6.117.021 7.868-.106 2.484.265 4.05.997 4.059.42.005.633-1.833 1.197-4.303 1.025-4.486 1.969-11.88 2.192-13.295.1-.633.18-1.602.514-2.429.124-.305.182-.674.23-1.077.17-1.402.261-4.87.233-6.663z"
    />
  </svg>
);
export default SvgNormal;
